import React from 'react';
import './BackButton.css';

const BackIcon = () => (
  <svg
    className="back-btn__icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Global back navigation button (HTML/CSS, no MUI).
 *
 * @param {string} label - Button text, e.g. "Back to Payment Settings"
 * @param {function} onClick - Click handler
 * @param {string} [className] - Extra classes (e.g. "back-btn--flush")
 * @param {boolean} [disabled]
 */
const BackButton = ({
  label = 'Back',
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  ...rest
}) => (
  <button
    type={type}
    className={['back-btn', className].filter(Boolean).join(' ')}
    onClick={onClick}
    disabled={disabled}
    {...rest}
  >
    <BackIcon />
    <span className="back-btn__label">{label}</span>
  </button>
);

export default BackButton;
